import React from "react";
import { COMPARE_OPTIONS, ICompareOptions } from "../defaults";
import { trackEvent } from "src/Amplitude";

const useCompareButton = () => {
  // compare options default
  const [compareOptions, setCompareOptions] = React.useState<ICompareOptions[]>(COMPARE_OPTIONS);

  // on compare click
  const [compareActive, setCompareActive] = React.useState<boolean>(false);

  // handle clicking on compare button
  const handleOnCompareClick = (): void => setCompareActive((prev): boolean => !prev);

  // handle toggling between compare options
  const handleOnCompareOptionToggle = (optionName: string): void => {
    trackEvent("Balance_Compare_Options", { button: optionName });
    setCompareOptions((prev): ICompareOptions[] => {
      return prev.map((opt): ICompareOptions => {
        if (opt.name === optionName) {
          return { ...opt, checked: !opt.checked };
        }
        return opt;
      });
    });
  };

  // handle  resetting compare options to DEFAULT
  const handleOnCompareClear = (): void => setCompareOptions(COMPARE_OPTIONS);

  return {
    compareOptions,
    compareActive,
    onClick: handleOnCompareClick,
    onToggle: handleOnCompareOptionToggle,
    onClear: handleOnCompareClear,
  };
};

export default useCompareButton;
